import { Status } from '../models/onboarding';
import { Injectable } from '@angular/core';

enum Event {
  analytics = 'GAevent',
  step = 'VirtualPageview',
  onb = 'OnboardingEvent',
}

enum Category {
  onboarding = 'Onboarding',
  attiva = 'attiva',
}

enum Action {
  callme = 'Richiamatemi',
  click = 'click',
  save = 'Salva e Sospendi',
  info = 'Info Button',
}

enum Label {
  ok = 'ok',
  ko = 'ko',
  summary = 'riepilogo-attiva',
}

enum VirtualUrl {
  init = '/attiva/documenti',
  user_info = '/attiva/titolare',
  contract_info = '/attiva/informazioni',
  supplies = '/attiva/fornitura',
  insurance = '/attiva/insurance',
  payment = '/attiva/pagamento',
  summary = '/attiva/riepilogo',
  complete = '/attiva/prossimi-passi',
}

enum VirtualTitle {
  init = 'Attiva - Documenti necessari',
  user_info = 'Attiva - Titolare della fornitura',
  contract_info = 'Attiva - Informazioni contrattuali',
  supplies = 'Attiva - Fornitura',
  insurance = 'Attiva - Opzioni Aggiuntive',
  payment = 'Attiva - Pagamento',
  summary = 'Attiva - Riepilogo',
  complete = 'Attiva - Prossimi passi',
}

@Injectable()
export class AlgGtmService {
  private dataLayer: any[];
  private window = window as any;

  constructor() {
    this.dataLayer = this.window.dataLayer;
  }

  public callmeEvent(status: boolean) {
    this.dataLayer.push({
      event: Event.analytics,
      eventCategory: Category.onboarding,
      eventAction: Action.callme,
      eventLabel: status ? Label.ok : Label.ko,
    });
  }

  public submitEvent() {
    this.dataLayer.push({
      event: Event.analytics,
      eventCategory: Category.attiva,
      eventAction: Action.click,
      eventLabel: Label.summary,
    });
  }

  public infoEvent() {
    this.dataLayer.push({
      event: Event.analytics,
      eventCategory: Category.attiva,
      eventAction: Action.info,
      eventLabel: Label.summary,
    });
  }

  public saveEvent(status: boolean) {
    this.dataLayer.push({
      event: Event.analytics,
      eventCategory: Category.onboarding,
      eventAction: Action.save,
      eventLabel: status ? Label.ok : Label.ko,
    });
  }

  public stepEvent(webStatus: Status, product: string, type: string) {
    this.dataLayer.push({
      event: Event.step,
      virtualPageURL: VirtualUrl[webStatus],
      virtualPageTitle: VirtualTitle[webStatus],
      nomeProdotto: product,
      type: type,
    });
  }

  public submitOnbEvent(eventAction: string, eventLabel: string = '') {
    this.dataLayer.push({
      event: Event.onb,
      eventCategory: Category.onboarding,
      eventAction: eventAction,
      eventLabel: eventLabel,
    });
  }

  public submitIncludeEvent(eventLabel: string = '') {
    this.dataLayer.push({
      event: Event.onb,
      eventCategory: Category.onboarding,
      eventAction: 'Click su link',
      eventLabel: eventLabel,
    });
  }

  public submitLibrettoCodeEvent(status: string) {
    this.dataLayer.push({
      event: Event.onb,
      eventCategory: Category.onboarding,
      eventAction: 'Codice libretto socio',
      eventLabel: status,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/alg-gtm.service.ts